module.exports = __webpack_public_path__ + "static/media/1POLICY2.7bbca493.jpg";